import routes from './routes';
import { SetRoutes } from 'components';

const BrandsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default BrandsPages;
